<template>
  <v-card class="indigo darken-2 white--text rounded-card" v-if="!logo">
    <v-layout align-center justify-center row fill-height class="pa-0 ma-0">
      <v-flex xs3 sm3 md3 class="pt-0 hidden-sm-and-down">
        <v-img src="../../img/miniatura_white.png" width="40px" class="ma-3" />
      </v-flex>
      <v-flex xs3 sm3 md3 class="pt-0 hidden-sm-and-up">
        <img src="../../assets/miniatura_white.png" width="40px" class="pa-2" />
      </v-flex>
      <v-flex xs9 sm9 md9 class="pt-0" v-if="!loading && currentUser">
        <span class="title">{{ currentUser.name }}</span>
        <v-chip
          class="ma-2 pa-0 white--text"
          :color="currentUser.status | formatUserStatusColor"
        >
          {{ currentUser.status | formatUserStatus }}
        </v-chip>
        <v-chip class="ma-2 pa-0 white--text" color="blue">
          ECONOMIZOU: {{ currentUser.total_savings | formatCurrency }}
        </v-chip>
        <v-chip class="ma-2 pa-0 white--text" color="blue">
          BÔNUS TOTAL: {{ bonus_total | formatCurrency }}
        </v-chip>
      </v-flex>
    </v-layout>
  </v-card>
  <v-card class="white darken-2 white--text rounded-card" v-else>
    <v-container>
      <v-layout align-center justify-center row fill-height class="pa-0 ma-0">
        <v-flex xs3 sm3 md3 class="pt-0 hidden-sm-and-down">
          <img :src="logo" width="120px" class="ml-3" />
          <!-- <v-img src="../../img/enercred_branco_300.png" width="120px" class="ml-3"/> -->
        </v-flex>
        <v-flex xs3 sm3 md3 class="pt-0 hidden-sm-and-up">
          <!-- <img src="../../assets/enercred_avatar_branco_100.png" width="60px" class="pa-2"/> -->
          <img :src="logo" width="60px" class="pa-2" />
        </v-flex>
        <v-flex xs9 sm9 md9 class="pt-0" v-if="!loading && currentUser">
          <span class="title indigo--text darken-3">{{
            currentUser.person_type === "pj"
              ? currentUser.company_name
              : currentUser.name
          }}</span>
          <v-chip
            class="ma-2 pa-0 white--text"
            :color="currentUser.status | formatUserStatusColor"
          >
            {{ currentUser.status | formatUserStatus }}
          </v-chip>
          <br />
          <span v-if="currentUser.person_type === 'pj'" class="black--text">{{
            currentUser.name
          }}</span>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>
<script>
import { mapState } from "vuex";
export default {
  data: () => ({
    logo: null,
  }),
  mounted() {
    let partner = localStorage.getItem("partner") || "enercred";
    // console.log('partner: ', partner)
    if (
      partner !== "enercred" &&
      partner !== "teste" &&
      partner !== "super" &&
      partner !== "localhost"
    ) {
      this.logo = "../../img/partner/" + partner + ".png";
    }
  },
  computed: {
    ...mapState("members", [
      "loading",
      "currentUser",
      "consumer_units",
      "consumer_unit",
    ]),
    bonus_total() {
      return this.consumer_units.reduce(
        (previousValue, currentValue) =>
          currentValue.hasOwnProperty("account_balance") === true
            ? previousValue + currentValue.account_balance
            : previousValue,
        0,
      );
    },
  },
  filters: {
    toCurrency(value) {
      if (!value) return "R$ 0";
      return "R$ " + value.toString().replace(".", ",");
    },
  },
};
</script>
<style scoped>
.rounded-card {
  border-radius: 0px;
}
</style>
